import React from "react";
import { Container, Header, NewChatContainer, Content, IconWrapper, DockWrapper } from "./Sidebar.styled";
import { AgentsList, ChatsList } from "./components";
import { Typography, Icon } from "@ann/web-components";

const Sidebar = ({
  isCollapsed,
  onToggleCollapse,
  selectedConversationId,
  onSelectConversation,
  selectedAgentId,
  onSelectAgent,
  onNewChat,
}) => {
  return (
    <Container>
      <Header $isCollapsed={isCollapsed}>
        <IconWrapper>
          <Icon color="primary-surface" name="brain" size={"small"} />
        </IconWrapper>
        <DockWrapper onClick={onToggleCollapse}>
          <Icon
            color="neutral"
            name="dock_to_right"
            size={"small"}
          />
        </DockWrapper>
        <IconWrapper className="sidebar-edit-icon-collapsed">
          <Icon color="neutral" name="edit_square" size={"small"} />
        </IconWrapper>
      </Header>

      <Content $isCollapsed={isCollapsed}>
        <NewChatContainer
          $isCollapsed={isCollapsed}
          $isSelected={!selectedConversationId && !selectedAgentId}
          onClick={onNewChat}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && onNewChat?.()}
        >
          <Icon color="neutral" name="edit_square" size="small" />
          <Typography category="body" size="medium" weight="regular" color="body">
            New Chat
          </Typography>
        </NewChatContainer>

        <AgentsList selectedAgentId={selectedAgentId} onSelectAgent={onSelectAgent} />

        <ChatsList
          selectedConversationId={selectedConversationId}
          onSelectConversation={onSelectConversation}
        />
        
      </Content>
    </Container>
  );
};

export default Sidebar;
